// Shared mobile "Got it" popup for the onboarding guide triggers (Gated,
// Favorites, Storefront). Same Bulma modal markup they each used to inline.
// `children` is the tip text/JSX; `onDismiss` fires on the button (and the
// background, unless `dismissOnBackground` is false).
function GuidePopup({ children, onDismiss, dismissOnBackground = true, buttonLabel = "Got it" }) {
  return (
    <div id="modal-js-example" className="modal is-active">
      <div
        className="modal-background"
        onClick={dismissOnBackground ? onDismiss : undefined}
      ></div>
      <div className="modal-content" style={{ width: "90vw" }}>
        <div className="box montserrat" style={{ textAlign: "center", fontWeight: "600" }}>
          <p style={{ fontSize: "2.4vh", marginBottom: "1.5vh" }}>{children}</p>
          <button
            className="button is-rounded"
            style={{ backgroundColor: "#8c3e7c", color: "#fff", fontWeight: "700" }}
            onClick={onDismiss}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GuidePopup;
